import { Cursor as BaseCursor } from '@studiometa/ui';

/**
 * Custom Cursor component
 * Extends the base Cursor from @studiometa/ui
 */
export default class Cursor extends BaseCursor {
  /**
   * Add transition on mount
   */
  mounted() {
    super.mounted();
  }

  /**
   * Override moved hook to handle opacity on StyledModal hover
   * @param {object} root0
   * @param {Event} root0.event
   * @param {number} root0.x
   * @param {number} root0.y
   * @param {boolean} root0.isDown
   */
  moved({ event, x, y, isDown }) {
    super.moved({ event, x, y, isDown });

    if (event && event.target instanceof Element) {
      const linkElement = event.target.closest('[data-link]');

      if (linkElement) {
        const linkText = linkElement.dataset.link;
        this.$el.textContent = linkText;
        this.$el.style.opacity = '1';
        this.$el.style.width = 'auto';
        this.$el.style.height = 'auto';
      } else {
        this.$el.textContent = '';
        this.$el.style.opacity = '';
        this.$el.style.width = '';
        this.$el.style.height = '';
      }
    }
  }
}
